export const API_URL = {
    HOST: process.env.REACT_APP_API_URL,
    GET_TOPICS_LIST: "https://crawler.deepaicare.com/api/topic",
} as const;
export enum CONST {
    HOT_TOPIC_ID = "8320840b-e2fc-42fa-9614-3dd66083d795",
}